import { resolveAttendanceTimezone } from 'src/utils/attendanceTime';
import { operationalColors } from 'src/components/OperationalTable/styles';

/** The Cancellations heading, shared by every section of the reference block below the Actuals table. */
export const actualsSectionHeadingSx = { mb: 1, fontWeight: 700, color: operationalColors.heading };

/** Show the event's actual offset/abbreviation on its date, never the viewer zone. */
export function actualsZoneLabel(record: any, instant?: string): string {
  const zone = resolveAttendanceTimezone(record);
  const date = instant ? new Date(instant) : new Date(`${String(record?.startDate ?? record?.shift?.startDate ?? '').slice(0, 10)}T12:00:00Z`);
  if (!Number.isFinite(date.getTime())) return zone;
  const abbreviation = new Intl.DateTimeFormat('en-US', { timeZone: zone, timeZoneName: 'short' })
    .formatToParts(date).find(part => part.type === 'timeZoneName')?.value;
  return abbreviation ? `${abbreviation} · ${zone}` : zone;
}
